import { render, staticRenderFns } from "./DeleteScheduledPostSuccess.vue?vue&type=template&id=2f29b232&scoped=true&"
var script = {}
import style0 from "./DeleteScheduledPostSuccess.vue?vue&type=style&index=0&id=2f29b232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29b232",
  null
  
)

export default component.exports